import '../App.css';
import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import Search from "./search/Search";
import Property from './property/Property';
import Footer from "./layout/Footer";

function App() {
  return (
    <div className="App">
      <Router>
        <div className="App-page">
          <Routes>
            <Route path="/" element={ <Search /> } />
            <Route path="/property/:id" element={ <Property /> } />
          </Routes>
        </div>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
